import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AutovalidationCard from "features/User/pages/ApprovalsManagement/components/CardApprovalsInfo/AutovalidationCard"
import CardHeader from "features/User/pages/ApprovalsManagement/components/CardApprovalsInfo/CardHeader"
import UsersSteps from "features/User/pages/ApprovalsManagement/components/CardApprovalsInfo/UsersSteps"
import { Accordion, AccordionTab } from "primereact/accordion"
import "./style.scss"

function ValidationElement({
  flujo,
  handleRemove,
  handleEdit,
  documentoNombre,
}: $TSMigrationFixMe) {
  return (
    // @ts-expect-error TS(2769): No overload matches this call.
    <Accordion className='mx-4 mt-3 mb-0 board-validation-item'>
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <AccordionTab
        header={
          <div className='d-flex justify-content-between w-100'>
            <CardHeader
              data={flujo}
              type={documentoNombre}
            />
            <div className='text-center d-flex justify-content-center align-items-center'>
              <FontAwesomeIcon
                icon={["fal", "pencil"]}
                className='mr-3'
                onClick={() => handleEdit(flujo.departamentoId)}
              />
              <FontAwesomeIcon
                icon={["fal", "trash-can"]}
                className='icon-delete'
                onClick={() => handleRemove(flujo.departamentoId)}
              />
            </div>
          </div>
        }
      >
        <div className='card-approval__content'>
          {flujo.autovalidacion ? (
            <AutovalidationCard flexContainer />
          ) : (
            <>
              {flujo.etapas?.map((etapa: $TSMigrationFixMe) => (
                <UsersSteps
                  key={etapa.departamentoId}
                  etapa={etapa}
                  flexContainer
                />
              ))}
            </>
          )}
        </div>
      </AccordionTab>
    </Accordion>
  )
}

export default ValidationElement
